import { useState } from 'react'
import agents from '../../../../api/agents/hooks'
import AdminLoader from '../../Components/AdminLoader/AdminLoader'
import CardTableView from '../../Components/CardTableView/CardTableView'

const UsersList = () => {
    const { data: users, isLoading } = agents.GetAgents.useQuery()

    const [filteredUsers, setFilteredUsers] = useState([])

    return isLoading ? (
        <AdminLoader />
    ) : (
        <CardTableView
            data={users}
            fetching={isLoading}
            filteredData={filteredUsers}
            editButtonLink={'/admin/user'}
            setFilteredData={setFilteredUsers}
            searchFields={{ firstName: 'firstName', lastName: 'lastName' }}
            isUserView={true}
        />
    )
}

export default UsersList
